import React, { FC, memo } from 'react'
import styled from 'styled-components'

import { Brand } from '@Generated/graphql'

type BrandLogoProps = {
  brand: Brand
}

const StyledWrapper = styled.div(({
  height: 13,
  // "px" needs to be explicit here, as we don't want 13em.
  lineHeight: '13px',
  maxWidth: 200,
}))

const StyledImage = styled.img(({
  display: 'inline-block',
  height: 13,
  maxWidth: '100%',
  opacity: '.75',
  verticalAlign: 'top',
  width: 'auto',
}))

export const BrandLogo: FC<BrandLogoProps> = memo(({ brand }) => {
  if (!brand.logo) { return null }

  const content = (
    <StyledImage
      alt={brand.title || ''}
      src={brand.logo}
      title={brand.title || ''}
    />
  )

  if (brand.url) {
    return <StyledWrapper><a href={brand.url}>{content}</a></StyledWrapper>
  }

  return <StyledWrapper>{content}</StyledWrapper>
})
